import React from 'react';
import { TextField } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';

const BookingFieldDate = ({ field, value, onChange, disabled }) => {
    const label = `${field.name} ${field.required ? '*' : ''}`;

    return (
        <DatePicker
            label={label}
            value={value}
            inputFormat="MMM D, YYYY"
            disableMaskedInput
            onChange={newValue => onChange(newValue)}
            disabled={disabled}
            renderInput={props => <TextField {...props} helperText="" disabled={disabled} />}
        />
    );
};

export default BookingFieldDate;
